module.exports = __webpack_public_path__ + "img/price.ee291ce3.svg";